import Vue from "vue";
import VueRouter from "vue-router";
import { registerApiRuntimeDeps } from "@/api/runtimeDeps";
import LoginView from "@/views/Login.vue";
import AdminView from "@/views/AdminView.vue";
import SettingView from "@/views/SettingsView/SettingView.vue";
import ReadinessCatalogsView from "@/views/ReadinessCatalogsView.vue";
import ReadinessEmployeeView from "@/views/ReadinessEmployee.vue";
import ResBadgeHolderView from "@/views/ResBadgeHolderView.vue";
import OrginationPositionView from "@/views/OrginationPositionView.vue";
import DetailEmployeeView from "@/views/DetailEmployeeView.vue";
import EmployeeDetailDashboardView from "@/views/DetailEmployeeViews/EmployeeDetailDashboardView.vue";
import RolePageView from "@/views/RolePageView.vue";
import BeMasterCoachView from "@/views/BeMasterCoachView.vue";
import EmployeeChatterView from "@/views/DetailEmployeeViews/EmployeeChatterView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import NotificationsListView from "@components/views/NotificationsListView.vue";
import NotFoundView from "@/views/NotFound.vue";
import EmployeeBadges from "@components/EmployeeBadges/EmployeeBadges.vue";
import EmployeeAssignments from "@/views/DetailEmployeeViews/EmployeeAssignmentView.vue";
import store from "../store";
import { useNotificationStore } from "@/store/pinia/notifications";
import AsEmployeeNewPage from "@/views/AsEmployeeNewPage.vue";
import PayRangeListView from "@/views/PayRanges/PayRangeListView.vue";
import DirectoriesView from "@/views/DirectoriesView.vue";
import CatalogDashboard from "@components/CatalogDashboard/CatalogDashboard.vue";
import ReadinessOrganization from "@/views/ReadinessOrganization.vue";
import EmployeePathToRedinessGateway from "@/views/DetailEmployeeViews/EmployeePathToRedinessGateway.vue";
import AsACoachPage from "@components/AsACoachPage/AsACoachPage.vue";
import ChecklistInspectionFormView from "@/views/ChecklistInspectionFormView.vue";
import launchDarklyService from "../services/launchdarkly";
import {
  LD_FLAG_IDEA_MDP_276_IMPERSONATION,
  LD_FLAG_ACCOUNT_ACTIVITY_STREAM,
  LD_FLAG_IDEA_MDP_423,
  LD_FLAG_IDEA_MDP_428,
  LD_FLAG_IDEA_MDP_429,
  LD_FLAG_IDEA_MDP_432,
  LD_FLAG_IDEA_MDP_546,
  LD_FLAG_IDEA_MDP_566,
  LD_FLAG_IDEA_MDP_581,
  LD_FLAG_IDEA_MDP_621,
  LD_FLAG_IDEA_MDP_650,
} from "@components/constants/launchDarklyFlagKeys";
import { TASKS_MODULE_LD_FLAG } from "@components/constants/tasksModule";
import {
  ORGANIZATION_JOB_CATEGORY_DETAIL_ROUTE_NAME,
  ORGANIZATION_JOB_FAMILY_DETAIL_ROUTE_NAME,
} from "@components/webmcp/navigation/routeConstants";
import {
  isInAccountReadOnlySession,
  isPreviewModeActive,
} from "@components/utils/impersonationSession";
import configService from "../services/config";
import * as Sentry from "@sentry/vue";
import {
  normalizeAdminPermission,
  resolveDefaultLoggedInRedirect,
} from "@/utils/defaultLoggedInRedirect";
import {
  isProductFairPayEnabled,
  isProductProceduresEnabled,
  refreshCurrentAccountDetails,
} from "@/utils/accountProductFlags";
import { resolveOrganizationEmployeeReadinessRedirect } from "@/utils/organizationEmployeeDetailTabs";
import { resolveOrganizationReadinessCatalogRedirect } from "@/utils/organizationReadinessCatalog";
import { getAvailableApps } from "@/api/appsAPI";
import { getListofAccount } from "@/api";
import { isYourStuffAllowed } from "@/utils/isYourStuffAllowed";
import { switchAccount } from "@/utils/switchAccount";
import OrganizationPage from "@components/OrganizationPage/OrganizationPage.vue";
import OrganizationLayout from "@components/OrganizationLayout/OrganizationLayout.vue";
import PositionForm from "@components/PositionForm/PositionForm.vue";
import RoleCard from "@components/RoleCard/RoleCard.vue";
import ResponsibilityCard from "@components/ResponsibilityCard/ResponsibilityCard.vue";
import YourStuffPage from "@components/YourStuffPage/YourStuffPage.vue";
import AsEmployeeLayout from "@components/YourStuffPage/AsEmployeeLayout.vue";
import EmployeeResponsibilities from "@components/YourStuffPage/EmployeeResponsibilities.vue";
import EmployeeAssignmentDetail from "@components/YourStuffPage/EmployeeAssignmentDetail.vue";
import YourStuffEmployeeBadges from "@components/YourStuffPage/EmployeeBadges.vue";
import EmployeePathToReadiness from "@components/YourStuffPage/EmployeePathToReadiness.vue";
import EmployeeInspectionRequests from "@components/YourStuffPage/EmployeeInspectionRequests.vue";
import AsCoachView from "@components/YourStuffPage/AsCoachView.vue";
import AsArchitectView from "@components/YourStuffPage/AsArchitectView.vue";
import YourProfileView from "@components/YourStuffPage/YourProfileView.vue";
import NewReadiness from "@/views/NewReadiness/NewReadiness.vue";
import FairPayComingSoonPage from "@/views/FairPayComingSoonPage/FairPayComingSoonPage.vue";
import FairPayPromoPageView from "@/views/FairPayPromoPage/FairPayPromoPage.vue";
import FairPayPage from "@/views/FairPay/FairPayPage.vue";
import PayRangeDetailView from "@/views/FairPay/PayRangeDetailView.vue";
import EmployeeFairPayCardView from "@/views/FairPay/EmployeeFairPayCardView.vue";
import PositionFairPayCardView from "@/views/FairPay/PositionFairPayCardView.vue";
import EmployeePayPlans from "@/views/FairPay/EmployeePayPlans.vue";
import PerformancePage from "@/views/Performance/PerformancePage.vue";
import ProceduresComingSoonPageView from "@/views/ProceduresComingSoonPage/ProceduresComingSoonPage.vue";
import TasksView from "@/views/Tasks/TasksView.vue";
import YourTasksEntry from "@/views/Tasks/YourTasksEntry.vue";
import PhoneTaskDetailView from "@/views/PhoneTasks/PhoneTaskDetailView.vue";
import ProceduresPage from "@/views/ProceduresPage/ProceduresPage.vue";
import AccountActivityView from "@/views/AccountActivity/AccountActivityView.vue";
import YourDashboard from "@components/YourDashboard/YourDashboard.vue";
import OnboardingWizardView from "@/views/OnboardingWizard/OnboardingWizardView.vue";
import KPIFormView from "@/views/Performance/KPIFormView.vue";
import { readWelcomeWizardIds, resolveWelcomeWizardEntry } from "@/utils/welcomeWizard";
Vue.use(VueRouter);

const checkAccountActivityStreamMiddleware = async (to, from, next) => {
  try {
    if (!launchDarklyService.isInitialized) {
      await launchDarklyService.initialize();
    }
    const enabled = await launchDarklyService.getFlag(LD_FLAG_ACCOUNT_ACTIVITY_STREAM, false);
    if (!enabled) {
      return next({ path: "/404" });
    }
    const raw = localStorage.getItem("accessPermission");
    const perm = raw ? JSON.parse(raw) : {};
    const { hasElevatedNav } = normalizeAdminPermission(perm);
    if (!hasElevatedNav) {
      return next({ path: "/404" });
    }
    next();
  } catch (error) {
    console.error("Error checking account activity stream access:", error);
    next({ path: "/404" });
  }
};

const organizationEmployeeReadinessProductGuard = async (to, from, next) => {
  try {
    const details = await refreshCurrentAccountDetails(getAvailableApps);
    const root = router.app?.$root;
    if (root && details) {
      root.currentAccountDetails = details;
      root.$emit("currentAccountDetailsUpdated", details);
    }
  } catch {
    // Route guard still applies using last-known currentAccountDetails.
  }

  const redirectPath = resolveOrganizationEmployeeReadinessRedirect(to);
  if (redirectPath) {
    next({ path: redirectPath, replace: true });
    return;
  }
  next();
};

const organizationReadinessCatalogGuard = async (to, from, next) => {
  let accountDetails;
  try {
    accountDetails = await refreshCurrentAccountDetails(getAvailableApps);
    const root = router.app?.$root;
    if (root && accountDetails) {
      root.currentAccountDetails = accountDetails;
      root.$emit("currentAccountDetailsUpdated", accountDetails);
    }
  } catch {
    accountDetails = undefined;
  }

  const pathNorm = (to.path || "").replace(/\/$/, "") || "/";
  const redirectPath = resolveOrganizationReadinessCatalogRedirect(pathNorm, to, accountDetails);
  if (redirectPath) {
    next({ path: redirectPath, replace: true });
    return;
  }
  next();
};

const checkMyStuffMiddleware = (to, from, next) => {
  const currentAccount = JSON.parse(localStorage.getItem("accessPermission") || "{}");
  if (isYourStuffAllowed(currentAccount)) {
    next();
    return;
  }
  next({ name: "NewOrganization", params: { tab: "dashboard" } });
};

export const checkLoginMiddleware = async (to, from, next) => {
  const loggedIn = localStorage.getItem("token") && localStorage.getItem("currentAccountID");

  if (loggedIn) {
    try {
      if (!launchDarklyService.isInitialized) {
        await launchDarklyService.initialize();
      }
      const newYourStuffEnabled = await launchDarklyService.getFlag(
        "my-stuff.new-your-stuff.enabled",
        false
      );
      const showNewOrganizationTab = true;
      const showNewReadinessTab = await launchDarklyService.getFlag("new-readiness", false);
      const showPerformanceTab = await launchDarklyService.getFlag("performance.enabled", false);
      const showFairPayTab = await launchDarklyService.getFlag("fair-pay.enabled", false);
      const ideaMDP432 = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_432, false);

      const accessPermissionStr = localStorage.getItem("accessPermission");
      const accessPermission = accessPermissionStr ? JSON.parse(accessPermissionStr) : {};
      return next(
        resolveDefaultLoggedInRedirect(accessPermission, {
          newYourStuffEnabled,
          showNewOrganizationTab,
          showNewReadinessTab,
          showPerformanceTab,
          showFairPayTab,
          ideaMDP432,
        })
      );
    } catch (error) {
      console.error("Error parsing accessPermission or checking flag:", error);
      return next({ name: "NewOrganization", params: { tab: "dashboard" } });
    }
  }
  next();
};

export const getDefaultRedirectForLoggedInFromFlags = async (accessPermission) => {
  const showNewOrganizationTab = true;
  const newYourStuffEnabled = await launchDarklyService.getFlag(
    "my-stuff.new-your-stuff.enabled",
    false
  );
  const showNewReadinessTab = await launchDarklyService.getFlag("new-readiness", false);
  const showPerformanceTab = await launchDarklyService.getFlag("performance.enabled", false);
  const showFairPayTab = await launchDarklyService.getFlag("fair-pay.enabled", false);
  const ideaMDP432 = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_432, false);
  return resolveDefaultLoggedInRedirect(accessPermission, {
    newYourStuffEnabled,
    showNewOrganizationTab,
    showNewReadinessTab,
    showPerformanceTab,
    showFairPayTab,
    ideaMDP432,
  });
};

export const checkYourStuffMiddleware = async (to, from, next) => {
  try {
    if (!launchDarklyService.isInitialized) {
      await launchDarklyService.initialize();
    }
    const newYourStuffEnabled = await launchDarklyService.getFlag(
      "my-stuff.new-your-stuff.enabled",
      false
    );
    const accessPermissionStr = localStorage.getItem("accessPermission");
    const accessPermission = accessPermissionStr ? JSON.parse(accessPermissionStr) : {};

    // Align with sidebar: your_stuff_permission (not has_employee alone).
    if (!newYourStuffEnabled || !isYourStuffAllowed(accessPermission)) {
      useNotificationStore().warning(
        `Your Stuff isn't available in ${accessPermission?.account_name || "this account"}`
      );
      return next(await getDefaultRedirectForLoggedInFromFlags(accessPermission));
    }

    const ideaMDP438 = await launchDarklyService.getFlag("idea-MDP-438", false);
    const pathNorm = (to.path || "").replace(/\/$/, "") || "/";

    if (pathNorm === "/your-stuff") {
      const redirect = ideaMDP438
        ? "/your-stuff/dashboard"
        : "/your-stuff/employee/responsibilities";
      return next({ path: redirect, replace: true });
    }
    if (!ideaMDP438 && pathNorm.startsWith("/your-stuff/dashboard")) {
      return next({ path: "/your-stuff/employee/responsibilities", replace: true });
    }
    next();
  } catch (error) {
    console.error("Error checking Your Stuff access:", error);
    return next({ name: "NewOrganization", params: { tab: "dashboard" } });
  }
};

const checkReadinessOrganizationMiddleware = async (to, from, next) => {
  try {
    // Check if the feature flag is enabled
    const showReadinessOrganizationTab = await launchDarklyService.getFlag(
      "hide_organizational_readiness",
      false
    );

    if (showReadinessOrganizationTab) {
      next();
    } else {
      // Redirect to readiness employees if organization tab is disabled
      next({ name: "Positions" });
    }
  } catch (error) {
    console.error("Error checking readiness organization flag:", error);
    // Default to allowing access if flag check fails
    next();
  }
};

/**
 * ER-11744 — the Job Category detail route (/organization/job-categories/:id)
 * is a new addressable surface and ships behind the same idea-MDP-566 flag that
 * gates the Job Categories list/detail components. When the flag is off the
 * route redirects to the (also flag-gated) Categories list, which OrganizationPage
 * falls back to Dashboard from when the feature is disabled.
 */
export const checkJobCategoryDetailMiddleware = async (to, from, next) => {
  try {
    if (!launchDarklyService.isInitialized) {
      await launchDarklyService.initialize();
    }
    const enabled = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_566, false);
    if (!enabled) {
      return next({ name: "NewOrganization", params: { tab: "categories" } });
    }
    next();
  } catch (error) {
    console.error("Error checking job category detail flag:", error);
    next({ name: "NewOrganization", params: { tab: "categories" } });
  }
};

/**
 * Middleware to check if Job Family detail route is accessible. If the flag is disabled,
 * falls back to Job Families list tab.
 */
export const checkJobFamilyDetailMiddleware = async (to, from, next) => {
  try {
    if (!launchDarklyService.isInitialized) {
      await launchDarklyService.initialize();
    }
    const enabled = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_581, false);
    if (!enabled) {
      return next({ name: "NewOrganization", params: { tab: "job-families" } });
    }
    next();
  } catch (error) {
    console.error("Error checking job family detail flag:", error);
    next({ name: "NewOrganization", params: { tab: "job-families" } });
  }
};

/** ER-12475: the KPI form ships behind idea-MDP-428; with the flag off the route is a 404. */
export const checkKpiFormMiddleware = async (to, from, next) => {
  try {
    if (!launchDarklyService.isInitialized) {
      await launchDarklyService.initialize();
    }
    const enabled = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_428, false);
    next(enabled ? undefined : { path: "/404" });
  } catch (error) {
    console.error("Error checking KPI form flag:", error);
    next({ path: "/404" });
  }
};

/** ER-12836: the phone Task detail ships behind idea-MDP-650; with the flag off it falls back to the list. */
export const checkPhoneTasksMiddleware = async (to, from, next) => {
  try {
    if (!launchDarklyService.isInitialized) {
      await launchDarklyService.initialize();
    }
    const enabled = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_650, false);
    next(enabled ? undefined : "/your-stuff/tasks");
  } catch (error) {
    console.error("Error checking phone tasks flag:", error);
    next("/your-stuff/tasks");
  }
};

// vue-router 3 accepts a single beforeEnter function, so chain the two guards by hand.
export const checkYourStuffPhoneTaskMiddleware = async (to, from, next) => {
  let proceed = false;
  await checkYourStuffMiddleware(to, from, (...args) => {
    if (args.length === 0) {
      proceed = true;
    } else {
      next(...args);
    }
  });
  if (proceed) {
    await checkPhoneTasksMiddleware(to, from, next);
  }
};

const FAIR_PAY_PROMO_PATH = "/fair-pay-promo";

const routes = [
  {
    path: "/",
    name: "",
    component: LoginView, // Won't actually render, beforeEach will redirect
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { hideMainSidebar: true },
    beforeEnter: checkLoginMiddleware,
  },
  {
    path: "/impersonation/handoff",
    name: "ImpersonationHandoff",
    component: LoginView,
    meta: { hideMainSidebar: true, impersonationHandoff: true },
  },
  {
    path: String.raw`/organization/employees/:id(\d+)`,
    name: "NewOrganizationDetailEmployee",
    component: DetailEmployeeView,
    meta: { secondSidebar: "employee" },
    beforeEnter: organizationEmployeeReadinessProductGuard,
    children: [
      {
        path: String.raw`/organization/employees/:id(\d+)/dashboard`,
        name: "NewOrganizationDetailEmployeeDashboard",
        component: EmployeeDetailDashboardView,
        meta: { secondSidebar: "employee" },
        beforeEnter: organizationEmployeeReadinessProductGuard,
      },
      {
        path: String.raw`/organization/employees/:id(\d+)/pathtoreadiness`,
        name: "NewOrganizationEmployeePathToReadiness",
        component: EmployeePathToRedinessGateway,
        meta: { secondSidebar: "employee" },
        beforeEnter: organizationEmployeeReadinessProductGuard,
      },
      {
        path: String.raw`/organization/employees/:id(\d+)/chatter`,
        name: "NewOrganizationEmployeeChatter",
        component: EmployeeChatterView,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/organization/employees/:id/assignment",
        name: "NewOrganizationEmployeeAssignments",
        component: EmployeeAssignments,
        meta: { secondSidebar: "employee" },
      },
      {
        path: String.raw`/organization/employees/:id(\d+)/badges`,
        name: "NewOrganizationEmployeeBadges",
        component: EmployeeBadges,
        meta: { secondSidebar: "employee" },
        beforeEnter: organizationEmployeeReadinessProductGuard,
      },
      {
        // ER-11639: Organization-scoped inspection — reuses AsCoachView/AsACoachTab
        // inside the employee record layout so Inspect from Organization stays
        // under Organization > Employees > [Employee] instead of Your Stuff.
        path: String.raw`/organization/employees/:id(\d+)/inspection`,
        name: "OrganizationEmployeeInspection",
        component: AsCoachView,
        meta: { secondSidebar: "employee" },
      },
    ],
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    meta: {
      sideBarPresent: false,
      le: "admin",
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: SettingView,
  },
  {
    // ER-11887: bookmarkable Configuration grid route. Selection of the
    // Configurations tab is handled by SettingView from the path.
    path: "/settings/configuration",
    name: "SettingsConfiguration",
    component: SettingView,
  },
  // ER-11888: bookmarkable per-tile routes. Each resolves to the same SettingView;
  // ConfigurationView reads $route.meta.configurationTile to select the matching
  // tile (the tile components need SettingView's data/event wiring, so they render
  // through ConfigurationView rather than as standalone route components).
  {
    path: "/settings/configuration/jobs",
    name: "SettingsConfigurationJobs",
    component: SettingView,
    meta: { configurationTile: "jobs" },
  },
  {
    path: "/settings/configuration/countries",
    name: "SettingsConfigurationCountries",
    component: SettingView,
    meta: { configurationTile: "country" },
  },
  {
    path: "/settings/configuration/currencies",
    name: "SettingsConfigurationCurrencies",
    component: SettingView,
    meta: { configurationTile: "currency" },
  },
  {
    path: "/settings/configuration/languages",
    name: "SettingsConfigurationLanguages",
    component: SettingView,
    meta: { configurationTile: "languages" },
  },
  {
    path: "/settings/configuration/directories",
    name: "SettingsConfigurationDirectories",
    component: SettingView,
    meta: { configurationTile: "directories" },
  },
  {
    path: "/settings/configuration/branding",
    name: "SettingsConfigurationBranding",
    component: SettingView,
    meta: { configurationTile: "branding" },
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswrd",
    component: ForgotPasswordView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/setup/password",
    name: "SetNewPassword",
    component: ForgotPasswordView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/reset/password",
    name: "SetNewPasswordReset",
    component: ForgotPasswordView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/my-stuff/employee",
    name: "AsEmployee",
    component: AsEmployeeNewPage,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/my-stuff/master",
    redirect: "/your-stuff/as-architect",
  },
  {
    path: "/my-stuff/coach",
    name: "AsCoach",
    component: AsACoachPage,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/my-stuff/coach/inspection/:employeeId/:responsibilityId",
    name: "ChecklistInspection",
    component: ChecklistInspectionFormView,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/directories",
    name: "Directories",
    component: DirectoriesView,
  },
  {
    path: "/readiness/catalogs",
    name: "ReadinessCatalogs",
    component: ReadinessCatalogsView,
  },
  {
    path: String.raw`/readiness/catalogs/:type(\w+)`,
    name: "ReadinessCatalogsDetail",
    component: ReadinessCatalogsView,
  },
  {
    path: String.raw`/readiness/catalogs/responsibilities/:objId(\d+)`,
    name: "ReadinessCatalogsDetailObjId",
    component: ResBadgeHolderView,
  },
  {
    path: String.raw`/organization/responsibilities/responsibility/:resId(\d+)/:tab?`,
    name: "ResponsibilityCard",
    component: ResponsibilityCard,
  },
  {
    path: String.raw`/my-stuff/master/responsibilities/:objId(\d+)`,
    redirect: "/your-stuff/as-architect",
  },
  {
    path: String.raw`/readiness/catalogs/roles/:objId(\d+)`,
    name: "ReadinessCatalogsDetailObjId",
    component: RolePageView,
  },
  {
    path: "/readiness/employees",
    name: "ReadinessEmployees",
    component: ReadinessEmployeeView,
  },
  {
    path: "/readiness/organization",
    name: "ReadinessOrganization",
    component: ReadinessOrganization,
    beforeEnter: checkReadinessOrganizationMiddleware,
  },
  {
    path: String.raw`/readiness/responsibility/holder/:resId(\d+)`,
    name: "ResBadgeHolder",
    component: ResBadgeHolderView,
  },
  {
    path: String.raw`/organization/positions/position/:pId(\d+)`,
    name: "OrgPosition",
    component: OrginationPositionView,
  },
  {
    path: String.raw`/readiness/catalogs/roles/:type(\w+)/:objId(\d+)`,
    name: "ReadinessCatalogsRolesResponse",
    component: ResBadgeHolderView,
  },
  {
    path: String.raw`/readiness/catalogs/roles/:roleId(\d+)/:type(\w+)/:objId(\d+)`,
    name: "ReadinessCatalogsRolesResponse",
    component: ResBadgeHolderView,
  },
  {
    path: String.raw`/readiness/catalogs/roles/:roleId(\d+)/attach/:type(\w+)/:objId(\d+)`,
    name: "ReadinessCatalogsResponsibilityResponse",
    component: ResBadgeHolderView,
  },
  {
    path: "/services/be-master-coach",
    name: "BeMasterCoach",
    component: BeMasterCoachView,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: NotificationsListView,
  },
  {
    path: "/compensation/pay-range-list",
    name: "PayRangeList",
    component: PayRangeListView,
  },
  {
    path: "/catalog-dashboard",
    name: "CatalogDashboard",
    component: CatalogDashboard,
  },
  {
    path: "/organization/positions/:positionId",
    name: "PositionDetail",
    component: OrganizationLayout,
    children: [
      {
        path: "",
        name: "PositionDetailChild",
        component: PositionForm,
      },
      {
        path: "roles/:roleId",
        name: "RoleDetailFromPosition",
        beforeEnter: organizationReadinessCatalogGuard,
        component: RoleCard,
        props: (route) => ({
          roleId: route.params.roleId,
          breadcrumbsList: [
            {
              text: "Positions",
              disabled: false,
              href: "/organization/positions",
            },
            {
              text: route.query.positionName || "Position",
              disabled: false,
              icon: "org_icon_position",
              positionId: route.params.positionId,
            },
            {
              text: "Role",
              disabled: true,
            },
          ],
        }),
      },
    ],
  },
  {
    path: "/organization/roles/:roleId",
    name: "RoleDetail",
    component: OrganizationLayout,
    beforeEnter: organizationReadinessCatalogGuard,
    children: [
      {
        path: "",
        name: "RoleDetailChild",
        component: RoleCard,
        props: (route) => ({
          roleId: route.params.roleId,
          breadcrumbsList: [
            {
              text: "Roles",
              disabled: false,
              href: "/organization/roles",
            },
            {
              text: "Role",
              disabled: true,
            },
          ],
        }),
      },
    ],
  },
  {
    path: "/organization/responsibilities/:resId",
    name: "ResponsibilityDetail",
    component: OrganizationLayout,
    beforeEnter: organizationReadinessCatalogGuard,
    children: [
      {
        path: "",
        name: "ResponsibilityDetailChild",
        component: ResponsibilityCard,
        props: (route) => ({
          resId: route.params.resId,
        }),
      },
    ],
  },
  {
    path: "/organization/positions/:positionId/roles/:roleId/responsibilities/:resId",
    name: "ResponsibilityDetailFromPositionRole",
    component: OrganizationLayout,
    beforeEnter: organizationReadinessCatalogGuard,
    children: [
      {
        path: "",
        name: "ResponsibilityDetailFromPositionRoleChild",
        component: ResponsibilityCard,
        props: (route) => ({
          resId: route.params.resId,
        }),
      },
    ],
  },
  {
    path: "/organization/roles/:roleId/responsibilities/:resId",
    name: "ResponsibilityDetailFromRole",
    component: OrganizationLayout,
    beforeEnter: organizationReadinessCatalogGuard,
    children: [
      {
        path: "",
        name: "ResponsibilityDetailFromRoleChild",
        component: ResponsibilityCard,
        props: (route) => ({
          resId: route.params.resId,
        }),
      },
    ],
  },
  {
    path: "/organization",
    redirect: "/organization/dashboard",
  },
  {
    // ER-11744 — addressable Job Category detail. Renders the same OrganizationPage
    // (Categories tab) with the drill-down driven by the :id route param instead of
    // the tab's local ref, so the detail survives refresh and can be deep-linked.
    path: "/organization/job-categories/:id",
    name: ORGANIZATION_JOB_CATEGORY_DETAIL_ROUTE_NAME,
    component: OrganizationPage,
    beforeEnter: checkJobCategoryDetailMiddleware,
  },
  {
    // ER-11742 — addressable Job Family detail. Renders the same OrganizationPage
    // (Job Families tab) with the drill-down driven by the :id route param instead of
    // the tab's in-component state, so the detail survives refresh and can be deep-linked.
    path: "/organization/job-families/:id",
    name: ORGANIZATION_JOB_FAMILY_DETAIL_ROUTE_NAME,
    component: OrganizationPage,
    beforeEnter: checkJobFamilyDetailMiddleware,
  },
  {
    path: "/organization/:tab",
    name: "NewOrganization",
    component: OrganizationPage,
    beforeEnter: organizationReadinessCatalogGuard,
  },
  {
    path: "/new-readiness",
    name: "NewReadiness",
    component: NewReadiness,
  },
  {
    // ER-12245 — the welcome wizard replaces the landing page until no page is
    // left (rule 3.6). Full screen: no sidebars, like the other takeover routes.
    path: "/welcome-wizard",
    name: "WelcomeWizard",
    component: OnboardingWizardView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/procedures/:bookId",
    name: "ProceduresBook",
    component: ProceduresPage,
  },
  {
    path: "/procedures",
    name: "Procedures",
    component: ProceduresPage,
  },
  {
    path: "/activity",
    name: "AccountActivity",
    component: AccountActivityView,
    beforeEnter: checkAccountActivityStreamMiddleware,
  },
  {
    path: "/procedures-coming-soon",
    name: "ProceduresComingSoon",
    component: ProceduresComingSoonPageView,
  },
  {
    path: "/your-stuff",
    name: "NewMyStuff",
    component: YourStuffPage,
    beforeEnter: checkYourStuffMiddleware,
    children: [
      {
        path: "dashboard",
        name: "YourStuffDashboard",
        component: YourDashboard,
        beforeEnter: checkYourStuffMiddleware,
      },
      {
        path: "employee",
        name: "AsEmployee",
        component: AsEmployeeLayout,
        redirect: "/your-stuff/employee/responsibilities",
        beforeEnter: checkYourStuffMiddleware,
        children: [
          {
            path: "responsibilities",
            name: "EmployeeResponsibilities",
            component: EmployeeResponsibilities,
            beforeEnter: checkYourStuffMiddleware,
          },
          {
            path: "responsibilities/:assignmentId",
            name: "EmployeeAssignmentDetail",
            component: EmployeeAssignmentDetail,
            beforeEnter: checkYourStuffMiddleware,
          },
          {
            path: "path-to-readiness",
            name: "EmployeePathToReadiness",
            component: EmployeePathToReadiness,
            beforeEnter: checkYourStuffMiddleware,
          },
          {
            path: "badges",
            name: "YourStuffEmployeeBadges",
            component: YourStuffEmployeeBadges,
            beforeEnter: checkYourStuffMiddleware,
          },
          {
            // ER-11510 — As Employee unified "Your Inspection Requests" tab.
            // Reachable via the gated menu item in AsEmployeeLayout
            // (idea-MDP-176); the list feed itself is ER-11504 (Blocked), so
            // the view renders the table's empty state until that ships.
            path: "inspection-requests",
            name: "EmployeeInspectionRequests",
            component: EmployeeInspectionRequests,
            beforeEnter: checkYourStuffMiddleware,
          },
        ],
      },
      {
        path: "coach",
        name: "AsCoachNew",
        component: AsACoachPage,
        props: { embedded: true },
        beforeEnter: checkYourStuffMiddleware,
      },
      {
        path: "as-architect",
        name: "AsArchitectNew",
        component: AsArchitectView,
        beforeEnter: checkYourStuffMiddleware,
      },
      {
        // Bookmarks and emails from before the Master → Architect rename (query string is kept).
        path: "master",
        redirect: "/your-stuff/as-architect",
      },
      {
        path: "tasks",
        name: "YourStuffTasks",
        component: YourTasksEntry,
        beforeEnter: checkYourStuffMiddleware,
      },
      {
        path: "tasks/:taskId",
        name: "YourStuffTaskDetail",
        component: PhoneTaskDetailView,
        props: true,
        beforeEnter: checkYourStuffPhoneTaskMiddleware,
      },
      {
        path: "procedures",
        name: "YourStuffProcedures",
        component: ProceduresPage,
        beforeEnter: checkYourStuffMiddleware,
      },
      {
        path: "directories",
        name: "YourStuffDirectories",
        component: DirectoriesView,
        beforeEnter: checkYourStuffMiddleware,
      },
      {
        path: "profile",
        name: "YourStuffProfile",
        component: YourProfileView,
        beforeEnter: checkYourStuffMiddleware,
      },
    ],
  },
  {
    path: "/performance",
    name: "Performance",
    component: PerformancePage,
  },
  {
    path: "/performance/kpis/:kpiId",
    name: "PerformanceKpiForm",
    component: KPIFormView,
    beforeEnter: checkKpiFormMiddleware,
  },
  {
    path: "/fair-pay",
    name: "FairPay",
    component: FairPayPage,
    children: [
      {
        // Keep the main app sidebar + Fair Pay tab menu mounted (ER-10957).
        path: "pay-ranges/:payRangeId",
        name: "FairPayPayRangeDetail",
        component: PayRangeDetailView,
        props: true,
      },
      {
        path: "employees/:employeeId",
        name: "FairPayEmployee",
        component: EmployeeFairPayCardView,
        props: true,
      },
      {
        path: "positions/:positionId",
        name: "FairPayPosition",
        component: PositionFairPayCardView,
        props: true,
      },
      {
        path: "employees/:employeeId/pay-plans",
        name: "EmployeePayPlans",
        component: EmployeePayPlans,
        props: true,
      },
    ],
  },
  {
    path: "/fair-pay-coming-soon",
    name: "FairPayComingSoon",
    component: FairPayComingSoonPage,
  },
  {
    path: FAIR_PAY_PROMO_PATH,
    name: "FairPayPromo",
    component: FairPayPromoPageView,
  },
  {
    path: "/tasks",
    name: "Tasks",
    component: TasksView,
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFoundView,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Let the HTTP layer navigate on 401 without statically importing this module
// (see src/api/runtimeDeps.js).
registerApiRuntimeDeps({ router });

// ─── router.beforeEach helpers ────────────────────────────────────────────────

const identifyLdTenant = async (loggedIn) => {
  if (!loggedIn) return;
  try {
    const userStr = localStorage.getItem("user");
    const accountId = localStorage.getItem("currentAccountID");
    const accessPermissionStr = localStorage.getItem("accessPermission");
    if (userStr && accountId && accessPermissionStr) {
      const user = JSON.parse(userStr);
      const permissions = JSON.parse(accessPermissionStr);
      const account = {
        id: Number.parseInt(accountId, 10),
        name: permissions.account_name || `Account ${accountId}`,
        owner_email: permissions.owner_email || user?.email,
      };
      await launchDarklyService.identifyTenant(user, account);
    }
  } catch (e) {
    console.warn("Could not identify LaunchDarkly context in router:", e);
  }
};

export const loadRouteFlags = async () => ({
  newYourStuffEnabled: await launchDarklyService.getFlag("my-stuff.new-your-stuff.enabled", false),
  showNewOrganizationTab: true,
  showNewReadinessTab: await launchDarklyService.getFlag("new-readiness", false),
  showPerformanceTab: await launchDarklyService.getFlag("performance.enabled", false),
  showFairPayTab: await launchDarklyService.getFlag("fair-pay.enabled", false),
  ideaMDP423: await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_423, false),
  ideaMDP429: await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_429, false),
  // Filled in the Fair Pay guard after a lightweight account refresh
  productFairPay: isProductFairPayEnabled(),
  ideaMDP432: await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_432, false),
  ideaMDP546: await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_546, false),
  ideaMDP575: await launchDarklyService.getFlag(TASKS_MODULE_LD_FLAG, false),
  ideaMDP438: await launchDarklyService.getFlag("idea-MDP-438", false),
  ideaMDP404: await launchDarklyService.getFlag(LD_FLAG_ACCOUNT_ACTIVITY_STREAM, false),
});

const isProceduresModulePath = (normalizedPath) =>
  normalizedPath === "/procedures" ||
  normalizedPath.startsWith("/procedures/") ||
  normalizedPath === "/organization/procedures" ||
  normalizedPath.startsWith("/organization/procedures/");

// Procedures shows only when the idea-MDP-423 kill switch AND the account's product switch are on.
// While off, only administrators reach the Coming Soon upsell; everyone else gets their landing page.
const handleProceduresProductGuard = async (
  normalizedPath,
  ideaMDP423,
  getDefaultRedirectForLoggedIn,
  next
) => {
  const isComingSoon = normalizedPath === "/procedures-coming-soon";
  if (!isComingSoon && !isProceduresModulePath(normalizedPath)) return false;

  await refreshCurrentAccountDetails(getAvailableApps);
  if (ideaMDP423 && isProductProceduresEnabled()) {
    if (!isComingSoon) return false;
    next({ path: "/procedures" });
    return true;
  }

  const raw = localStorage.getItem("accessPermission");
  const perm = raw ? JSON.parse(raw) : {};
  if (!normalizeAdminPermission(perm).hasElevatedNav) {
    next(getDefaultRedirectForLoggedIn(perm));
    return true;
  }
  if (isComingSoon) return false;
  next({ path: "/procedures-coming-soon" });
  return true;
};

const isFairPayModulePath = (normalizedPath) =>
  normalizedPath === "/fair-pay" ||
  normalizedPath === "/fair-pay-coming-soon" ||
  normalizedPath === FAIR_PAY_PROMO_PATH ||
  normalizedPath.startsWith("/fair-pay/");

// Fair Pay shows only while the account's product switch is on. While it is off, idea-MDP-429
// sends administrators to the promotion page and everyone else to their landing page; without
// the flag everyone gets the legacy Coming Soon page.
const handleFairPayProductGuard = async (
  normalizedPath,
  flags,
  getDefaultRedirectForLoggedIn,
  next
) => {
  if (!isFairPayModulePath(normalizedPath)) return false;

  await refreshCurrentAccountDetails(getAvailableApps);
  const productFairPay = isProductFairPayEnabled();
  const isLandingPage =
    normalizedPath === "/fair-pay-coming-soon" || normalizedPath === FAIR_PAY_PROMO_PATH;
  if (productFairPay) {
    if (!isLandingPage) return false;
    next({ path: "/fair-pay" });
    return true;
  }

  if (!flags?.ideaMDP429) {
    if (normalizedPath === "/fair-pay-coming-soon") return false;
    next({ path: "/fair-pay-coming-soon" });
    return true;
  }

  const raw = localStorage.getItem("accessPermission");
  const perm = raw ? JSON.parse(raw) : {};
  if (!normalizeAdminPermission(perm).hasElevatedNav) {
    const landing = getDefaultRedirectForLoggedIn(perm);
    // The default landing can itself be /fair-pay; fall back to Organization to avoid a loop.
    const isFairPayLanding =
      typeof landing?.path === "string" && landing.path.startsWith("/fair-pay");
    next(isFairPayLanding ? { name: "NewOrganization", params: { tab: "dashboard" } } : landing);
    return true;
  }
  if (normalizedPath === FAIR_PAY_PROMO_PATH) return false;
  next({ path: FAIR_PAY_PROMO_PATH });
  return true;
};

export const handleProcedureTaskAndActivityGuards = async (
  normalizedPath,
  flags,
  next,
  getDefaultRedirectForLoggedIn
) => {
  const { ideaMDP423, ideaMDP575 } = flags;
  if (
    await handleProceduresProductGuard(
      normalizedPath,
      ideaMDP423,
      getDefaultRedirectForLoggedIn,
      next
    )
  )
    return true;

  if (await handleFairPayProductGuard(normalizedPath, flags, getDefaultRedirectForLoggedIn, next))
    return true;

  if (!ideaMDP575 && normalizedPath === "/tasks") {
    next({ path: "/404" });
    return true;
  }
  const { ideaMDP404 } = flags;
  if (normalizedPath === "/activity" && !ideaMDP404) {
    next({ path: "/404" });
    return true;
  }
  return false;
};

export const handleDashboardAndMdp432Guard = async (
  normalizedPath,
  flags,
  getDefaultRedirectForLoggedIn,
  next
) => {
  const { ideaMDP432, ideaMDP438, newYourStuffEnabled } = flags;
  if (normalizedPath === "/your-stuff" || normalizedPath.startsWith("/your-stuff/")) {
    // View-as / Preview (ER-10317): always allow Your Stuff — do not bounce to Organization.
    if (!isInAccountReadOnlySession()) {
      try {
        const raw = localStorage.getItem("accessPermission");
        const perm = raw ? JSON.parse(raw) : {};
        if (!newYourStuffEnabled || !isYourStuffAllowed(perm)) {
          useNotificationStore().warning(
            `Your Stuff isn't available in ${perm?.account_name || "this account"}`
          );
          next(getDefaultRedirectForLoggedIn(perm));
          return true;
        }
      } catch (error) {
        console.error("Error checking Your Stuff route access:", error);
        next({ name: "NewOrganization", params: { tab: "dashboard" } });
        return true;
      }
    }
  }
  if (normalizedPath === "/your-stuff") {
    const redirect = ideaMDP438 ? "/your-stuff/dashboard" : "/your-stuff/employee/responsibilities";
    next({ path: redirect, replace: true });
    return true;
  }
  if (!ideaMDP438 && normalizedPath.startsWith("/your-stuff/dashboard")) {
    next({ path: "/your-stuff/employee/responsibilities" });
    return true;
  }
  if (!ideaMDP432) return false;
  try {
    const raw = localStorage.getItem("accessPermission");
    // No hydrated access data yet — fail open rather than treating an empty
    // permission object as "no access" and hard-redirecting mid-session.
    if (!raw) return false;
    const perm = JSON.parse(raw);
    const { hasElevatedNav, isOwner, isCoOwner } = normalizeAdminPermission(perm);
    const restricted = [
      "/new-readiness",
      "/performance",
      "/fair-pay",
      "/fair-pay-coming-soon",
      "/tasks",
      "/procedures",
      "/settings",
    ];
    const isRestrictedFairPayDetail =
      normalizedPath.startsWith("/fair-pay/pay-ranges/") ||
      normalizedPath.startsWith("/fair-pay/employees/") ||
      normalizedPath.startsWith("/performance/kpis/");
    const isSettingsPath =
      normalizedPath === "/settings" || normalizedPath.startsWith("/settings/");
    if (
      !hasElevatedNav &&
      (restricted.includes(normalizedPath) || isSettingsPath || isRestrictedFairPayDetail)
    ) {
      next({ path: "/404" });
      return true;
    }
    if (isSettingsPath && hasElevatedNav && !(isOwner || isCoOwner)) {
      next(getDefaultRedirectForLoggedIn(perm));
      return true;
    }
  } catch (error) {
    console.error("Error checking idea-MDP-432 route access:", error);
  }
  return false;
};

export const handleOrganizationGuard = async (to, flags, getDefaultRedirectForLoggedIn, next) => {
  if (!to.path.startsWith("/organization")) return false;
  const { showNewOrganizationTab, ideaMDP432 } = flags;
  try {
    const raw = localStorage.getItem("accessPermission");
    // No hydrated access data yet — fail open rather than treating an empty
    // permission object as "no access" and hard-redirecting mid-session.
    if (!raw) return false;
    const perm = JSON.parse(raw);
    const { isOwnerOrCoOwner, isAdmin } = normalizeAdminPermission(perm);
    const hasAccess = showNewOrganizationTab && (isOwnerOrCoOwner || (ideaMDP432 && isAdmin));
    if (!hasAccess) {
      // ER-11267: the redirect is silent from the visitor's point of view — explain it.
      // Deliberately generic because this guard covers the whole /organization/* tree.
      useNotificationStore().warning("You don't have permission to view that page.");
      next(getDefaultRedirectForLoggedIn(perm, { skipOrganization: true }));
      return true;
    }
  } catch (error) {
    console.error("Error checking organization access:", error);
  }
  return false;
};

// Return the path of the first `[enabled, path]` pair whose flag is truthy, else null.
const firstEnabledPath = (candidates) => {
  for (const [enabled, path] of candidates) {
    if (enabled) return path;
  }
  return null;
};

const getTabFallbackPath = (pathNorm, flags, isOwnerOrCoOwner) => {
  const { showNewReadinessTab, showPerformanceTab, showFairPayTab } = flags;
  if (pathNorm === "/new-readiness" && !showNewReadinessTab) {
    return firstEnabledPath([
      [showPerformanceTab, "/performance"],
      [showFairPayTab, "/fair-pay"],
      [isOwnerOrCoOwner, "/settings"],
    ]);
  }
  if (pathNorm === "/performance" && !showPerformanceTab) {
    return firstEnabledPath([
      [showFairPayTab, "/fair-pay"],
      [isOwnerOrCoOwner, "/settings"],
    ]);
  }
  if (
    (pathNorm === "/fair-pay" ||
      pathNorm === "/fair-pay-coming-soon" ||
      pathNorm === FAIR_PAY_PROMO_PATH) &&
    !showFairPayTab
  ) {
    return firstEnabledPath([[isOwnerOrCoOwner, "/settings"]]);
  }
  return undefined;
};

const handleTabFlagGuards = async (to, flags, getDefaultRedirectForLoggedIn, next) => {
  try {
    const pathNorm = to.path.replace(/\/$/, "") || "/";
    const raw = localStorage.getItem("accessPermission");
    const perm = raw ? JSON.parse(raw) : {};
    const isOwner = perm?.admin_permission === "owner";
    const isCoOwner = perm?.admin_permission === "co-owner";
    const fallback = getTabFallbackPath(pathNorm, flags, isOwner || isCoOwner);
    if (fallback === undefined) return false;
    next(fallback ? { path: fallback } : getDefaultRedirectForLoggedIn(perm));
    return true;
  } catch (error) {
    console.error("Error checking tab access:", error);
    return false;
  }
};

const isRootPath = (to) =>
  to.path === "/" ||
  to.path === "" ||
  to.fullPath === "/" ||
  to.fullPath?.replace(/\?.*$/, "") === "/";

/**
 * ER-12245: the welcome wizard replaces the landing page until no page is left
 * (rule 3.6). Returns the wizard path, or `null` to keep the normal landing.
 * Fails open — the wizard is a flag-gated surface and must never block entry.
 */
const resolveWelcomeWizardPath = async () => {
  const enabled = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_621, false);
  if (!enabled) return null;
  const { accountId, accessId } = readWelcomeWizardIds();
  return resolveWelcomeWizardEntry({ accountId, accessId, enabled });
};

const handleAuthAndInitialRedirects = async (
  to,
  normalizedPath,
  loggedIn,
  authRequired,
  getDefaultRedirectForLoggedIn,
  next
) => {
  if (authRequired && !loggedIn) {
    if (to.fullPath == "/") {
      next("/login");
      return true;
    }
    Sentry.setUser(null);
    configService.clearSecureConfig();
    localStorage.clear();
    launchDarklyService.resetToAnonymous();
    next({ path: "/login", query: { nextUrl: to.fullPath } });
    return true;
  }
  if ((normalizedPath === "/login" || isRootPath(to)) && loggedIn) {
    try {
      const raw = localStorage.getItem("accessPermission");
      const accessPermission = raw ? JSON.parse(raw) : {};
      const wizardPath = await resolveWelcomeWizardPath();
      if (wizardPath) {
        next(wizardPath);
        return true;
      }
      next(getDefaultRedirectForLoggedIn(accessPermission));
    } catch (error) {
      console.error("Error parsing accessPermission:", error);
      next({ name: "NewOrganization", params: { tab: "dashboard" } });
    }
    return true;
  }
  return false;
};

// ──────────────────────────────────────────────────────────────────────────────

// Gate the impersonation handoff route behind idea-MDP-276. Returns true when it
// has already redirected (caller should stop), false to continue normally.
const handleImpersonationHandoffGuard = async (normalizedPath, next) => {
  if (normalizedPath !== "/impersonation/handoff") return false;
  const ideaMDP276 = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_276_IMPERSONATION, false);
  if (!ideaMDP276) {
    next("/login");
    return true;
  }
  return false;
};

/** ER-10317 Preview: keep the user inside Your Stuff only. View-as uses real role (ER-11088). */
export const handlePreviewModeGuard = (normalizedPath, next) => {
  if (!isPreviewModeActive()) return false;
  if (
    normalizedPath.startsWith("/your-stuff") ||
    normalizedPath === "/impersonation/handoff" ||
    normalizedPath === "/login"
  ) {
    return false;
  }
  next({ path: "/your-stuff/employee/responsibilities", replace: true });
  return true;
};

// ER-12027: switch to the account named by ?accountId= before the Your Stuff
// access check runs, then land on the same route with accountId stripped.
export const handleDeepLinkAccount = async (to, getDefaultRedirectForLoggedIn, next) => {
  const rawAccountId = to?.query?.accountId;
  if (rawAccountId == null || String(rawAccountId).trim() === "") return false;

  const loggedIn = Boolean(
    localStorage.getItem("token") && localStorage.getItem("currentAccountID")
  );
  // Logged-out deep links are carried through ?nextUrl= and resolved in Login.vue.
  if (!loggedIn) return false;

  const accountId = String(Array.isArray(rawAccountId) ? rawAccountId[0] : rawAccountId);
  const currentAccountId = localStorage.getItem("currentAccountID");
  const rest = { ...(to.query || {}) };
  delete rest.accountId;

  // Same account: the param is redundant — just strip it and continue.
  if (String(currentAccountId) === accountId) {
    next({ ...to, query: rest, replace: true });
    return true;
  }

  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (!user?.id) {
      next({ ...to, query: rest, replace: true });
      return true;
    }

    // Fetch a generous page so a multi-account user's target is not missed by
    // pagination; getListofAccount is the same membership source Login.vue uses.
    const res = await getListofAccount(user.id, { limit: 100 });
    const accounts = res?.data?.results || [];
    const targetAccount = accounts.find((account) => String(account?.id) === accountId);

    if (!targetAccount) {
      useNotificationStore().warning("You don't have access to that account");
      const raw = localStorage.getItem("accessPermission");
      next(getDefaultRedirectForLoggedIn(raw ? JSON.parse(raw) : {}));
      return true;
    }

    await switchAccount(targetAccount, user);
    next({ ...to, query: rest, replace: true });
    return true;
  } catch (error) {
    console.error("Error switching account for deep link:", error);
    next({ ...to, query: rest, replace: true });
    return true;
  }
};

// Run the logged-in redirect guards in order. Returns true once any guard has
// taken over navigation (caller should stop), false when none applied.
const runLoggedInRedirectGuards = async (
  to,
  normalizedPath,
  flags,
  getDefaultRedirectForLoggedIn,
  next
) => {
  if (handlePreviewModeGuard(normalizedPath, next)) return true;
  if (
    await handleProcedureTaskAndActivityGuards(
      normalizedPath,
      flags,
      next,
      getDefaultRedirectForLoggedIn
    )
  )
    return true;
  if (
    await handleDashboardAndMdp432Guard(normalizedPath, flags, getDefaultRedirectForLoggedIn, next)
  )
    return true;
  if (await handleOrganizationGuard(to, flags, getDefaultRedirectForLoggedIn, next)) return true;
  if (await handleTabFlagGuards(to, flags, getDefaultRedirectForLoggedIn, next)) return true;
  return false;
};

const accountActivityStreamRouterBeforeEach = async (to, from, next) => {
  const publicPages = [
    "/login",
    "/forgot-password",
    "/setup/password",
    "/reset/password",
    "/impersonation/handoff",
  ];
  const normalizedPath = (to.path || "").replace(/\/$/, "") || "/";
  const authRequired = !publicPages.includes(normalizedPath);
  const loggedIn = localStorage.getItem("token") && localStorage.getItem("currentAccountID");

  if (!launchDarklyService.isInitialized) await launchDarklyService.initialize();

  if (await handleImpersonationHandoffGuard(normalizedPath, next)) return;

  await identifyLdTenant(loggedIn);
  const flags = await loadRouteFlags();
  const {
    newYourStuffEnabled,
    showNewOrganizationTab,
    showNewReadinessTab,
    showPerformanceTab,
    showFairPayTab,
    ideaMDP432,
  } = flags;
  store.dispatch("routeErrorHandling/clearError");

  const getDefaultRedirectForLoggedIn = (accessPermission, redirectOpts = {}) =>
    resolveDefaultLoggedInRedirect(accessPermission, {
      newYourStuffEnabled,
      showNewOrganizationTab,
      showNewReadinessTab,
      showPerformanceTab,
      showFairPayTab,
      ideaMDP432,
      ...redirectOpts,
    });

  if (
    await handleAuthAndInitialRedirects(
      to,
      normalizedPath,
      loggedIn,
      authRequired,
      getDefaultRedirectForLoggedIn,
      next
    )
  )
    return;

  if (await handleDeepLinkAccount(to, getDefaultRedirectForLoggedIn, next)) return;

  if (
    loggedIn &&
    (await runLoggedInRedirectGuards(
      to,
      normalizedPath,
      flags,
      getDefaultRedirectForLoggedIn,
      next
    ))
  )
    return;

  if (!authRequired && !loggedIn) {
    Sentry.setUser(null);
    configService.clearSecureConfig();
    localStorage.clear();
    launchDarklyService.resetToAnonymous();
  }
  sessionStorage.setItem("navigated", from.name);
  next();
};

router.beforeEach(accountActivityStreamRouterBeforeEach);

export default router;

const RECOVERABLE_CHUNK_ERROR_PATTERN =
  /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed|Unexpected token ['"]?</i;

// Suppress Vue Router navigation failures (Redirected / Duplicated / Cancelled)
// from being reported by Sentry as unhandled errors — these are expected guard
// behaviours when multiple navigations compete or the auth guard redirects.
// ref: EXIQTIVE-ACCOUNT-6N, EXIQTIVE-ACCOUNT-9G, EXIQTIVE-ACCOUNT-AF
router.onError((err) => {
  const message = err?.message || String(err || "");

  if (
    err &&
    (err.name === "NavigationDuplicated" ||
      (message && message.includes("Redirected when going from")) ||
      (message && message.includes("Navigation cancelled from")))
  ) {
    return;
  }

  if (err && (err.name === "ChunkLoadError" || RECOVERABLE_CHUNK_ERROR_PATTERN.test(message))) {
    return;
  }

  throw err;
});
